import * as React from "react"
import { Box, VStack, Checkbox, Text } from "@chakra-ui/react"

interface Props {
  showDropzones: boolean
  showServiceZones: boolean
  showMaintenanceZones: boolean
  onDropzoneToggle: () => void
  onServiceZoneToggle: () => void
  onMaintenanceToggle: () => void
}

export const MapZoneControl = (props: Props) => {
  return (
    <Box zIndex={8} position="absolute" bottom={4} right={4} bg="white" shadow="lg" rounded="md" p={4}>
      <VStack spacing={2} align="flex-start">
        <Text fontWeight="500">Show zones on map</Text>
        <Checkbox defaultChecked={props.showDropzones} onChange={() => props.onDropzoneToggle()} w={140}>
          Dropzones
        </Checkbox>
        <Checkbox
          w={140}
          colorScheme="purple"
          defaultChecked={props.showServiceZones}
          onChange={() => props.onServiceZoneToggle()}
        >
          Service areas
        </Checkbox>
        <Checkbox
          w={140}
          colorScheme="gray"
          defaultChecked={props.showMaintenanceZones}
          onChange={() => props.onMaintenanceToggle()}
        >
          Maintenance
        </Checkbox>
      </VStack>
    </Box>
  )
}
